import React from "react";

import { Grid, Typography } from "@mui/material";

interface IAvailabilityTopHeadingProps {
  title: string;
}

const AvailabilityTopHeading: React.FC<IAvailabilityTopHeadingProps> = ({
  title,
}) => {
  return (
    <Grid
      item
      sx={{
        display: { xs: "none", lg: "block" },
        position: "sticky",
        top: "0",
        backgroundColor: "var(--neutral-100)",
      }}
    >
      <Typography
        component={"h5"}
        sx={{
          color: "var(--gray-350)",
          padding: "0.8rem",
          fontSize: "1.2rem",
          fontWeight: 500,
        }}
      >
        {title}
      </Typography>
    </Grid>
  );
};

export default AvailabilityTopHeading;
